<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="580px"
    @click:outside="cerrarDialogo(false)"
  >
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="agregar()">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <!-- Toolbar Header Principal -->
        <v-toolbar
          color="secondary"
          dark
          flat
          class="table-header-toolbar px-2 px-sm-4"
        >
          <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
            <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
              <v-icon color="white">{{
                isNuevo ? "mdi-factory" : "mdi-pencil-box-outline"
              }}</v-icon>
            </div>
            <div class="header-text-block min-width-0 mr-2 mr-sm-3">
              <div class="header-company-title font-weight-bold text-truncate">
                {{ isNuevo ? "Nueva Planta" : "Editar Planta" }}
              </div>
            </div>
            <v-chip
              v-if="!isNuevo && Item.id"
              small
              color="white"
              text-color="secondary"
              class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
            >
              <v-icon left size="15" color="secondary">mdi-pound</v-icon>
              ID: {{ Item.id }}
            </v-chip>
          </div>

          <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
            <v-btn
              icon
              dark
              @click="cerrarDialogo(false)"
              class="btn-circle-tooltip"
            >
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </v-toolbar>

        <v-card-text class="pa-3 pa-sm-4 pa-md-5">
          <!-- SECCIÓN: DATOS DE LA PLANTA -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-domain</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Información de la Planta
            </span>
          </div>

          <!-- Mensaje Informativo -->
          <v-alert
            dense
            text
            type="info"
            icon="mdi-information-outline"
            class="rounded-lg mb-4 text-caption"
          >
            Ingrese la información básica de la planta operativa y su dirección correspondiente.
          </v-alert>

          <v-row dense>
            <!-- Campo Nombre -->
            <v-col cols="12" class="pa-2">
              <v-text-field
                label="Nombre de la planta *"
                placeholder="Ej: Planta Principal, Planta Lurín..."
                hide-details="auto"
                v-model="Item.nombre"
                outlined
                dense
                prepend-inner-icon="mdi-factory"
                class="rounded-lg"
                :rules="[(v) => !!v || 'El nombre es requerido']"
                required
              ></v-text-field>
            </v-col>

            <!-- Campo Dirección -->
            <v-col cols="12" class="pa-2">
              <v-text-field
                label="Dirección *"
                placeholder="Ej: Av. Industrial 1234, Lima..."
                hide-details="auto"
                v-model="Item.direccion"
                outlined
                dense
                prepend-inner-icon="mdi-map-marker-outline"
                class="rounded-lg"
                :rules="[(v) => !!v || 'La dirección es requerida']"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 text-caption text--secondary">
            <v-icon x-small color="error" class="mr-1">mdi-asterisk</v-icon>
            <span>Campos obligatorios</span>
          </div>
        </v-card-text>

        <!-- Botones de Acción / Footer -->
        <v-card-actions class="form-card-actions pa-3 pa-sm-4 bg-light border-top d-flex justify-end align-center">
          <v-btn
            outlined
            color="grey darken-1"
            class="btn-form-action text-capitalize px-4 rounded-lg mr-sm-2 font-weight-medium"
            @click="cerrarDialogo(false)"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            elevation="2"
            class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
            :loading="loading"
            :disabled="loading || !valid"
            @click="agregar()"
          >
            <v-icon left small>{{ isNuevo ? 'mdi-content-save' : 'mdi-pencil' }}</v-icon>
            {{ isNuevo ? 'Guardar Planta' : 'Actualizar Planta' }}
          </v-btn>
        </v-card-actions>

        <MensajeTransicion
          color="#FA694A"
          :text="mensaje"
          v-if="verAlerta"
          :top="true"
          :bottom="false"
        />
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import MensajeTransicion from "../Alerta.vue";
import { notif } from "@/plugins/notyf";

export default {
  props: ["dialog", "Item"],
  components: {
    MensajeTransicion
  },
  data() {
    return {
      valid: false,
      mensaje: "",
      verAlerta: false,
      loading: false
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    isNuevo() {
      return !this.Item || this.Item.id == null || this.Item.id === "";
    }
  },
  methods: {
    ...mapActions("plantas", ["cargarPlantas"]),

    async agregar() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        return;
      }

      try {
        const url = "plantas/store";
        this.loading = true;
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          planta: this.Item
        };

        await this.registrarPlanta(url, data);
      } catch (error) {
        this.loading = false;
        console.error("Error en agregar planta:", error);
      }
    },

    async registrarPlanta(url, data) {
      try {
        await axios.post(url, data);
        await this.cargarPlantas();
        this.cerrarDialogo(true);
      } catch (error) {
        this.loading = false;
        this.errorMessage = error.response ? error.response.data : error;
        console.error("error!", error);
        notif.error("Error al registrar la planta");
      }
    },

    cerrarDialogo(valor = false) {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.loading = false;
      if (valor) {
        notif.success(
          this.isNuevo
            ? "Planta registrada con éxito"
            : "Planta actualizada con éxito"
        );
      }
      this.$emit("dialog", false);
    }
  }
};
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc;
}

.border-top {
  border-top: 1px solid #e2e8f0;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }
}
</style>
